export default function ($translate) {
    return {
        KEYS: {
            FILE: 'FILE',
            URL: 'URL'
        },
        LABELS: {
            FILE: $translate.instant('question.File'),
            URL: $translate.instant('question.URL')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/questions/videoType/index.js